import { Group, Stack, Title, Text, Box } from '@mantine/core';
import React from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => {
    return (
        <Group justify="space-between" align="flex-end" mb="lg">
            <Box>
                <Title order={2}>{title}</Title>
                {subtitle && <Text c="dimmed">{subtitle}</Text>}
            </Box>
            {actions && (
                <Group>
                    {actions}
                </Group>
            )}
        </Group>
    );
};
